import { COMPANY_DETAILS_CONSTANT } from '../actionConstants';
import { failedFor, successFor } from '../sagaUtil';
import { apiKeyFields, defaultCurrency } from '../../companyDetails/config';
import { formatedCurencyField } from 'UtilityComponents/companyDetailsUtil';
import { COMPANY_DETAILS_CONSTS } from 'AppConstants';

const INITIAL_STATE = {
	apiLoader: false,
	apiSuccess: false,
	apiError: false,
	data: {},
	showModal: false,
	currenciesData: {
		currencies: [],
		apiLoader: true,
		apiError: false,
		apiSuccess: false
	},
	clientApiFields: apiKeyFields,
	defaultCurrency: formatedCurencyField(defaultCurrency.cCode, defaultCurrency.currency)
};

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}
	const { type, payload = {} } = action;
	switch (type) {
		case COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_CALLED: {
			return {
				...state,
				apiLoader: true,
				apiError: false,
				apiSuccess: false
			};
		}
		case COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_SUCCESS: {
			return {
				...state,
				apiLoader: false,
				apiSuccess: true,
				apiError: false
			};
		}
		case COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_FAILED: {
			return {
				...state,
				apiLoader: false,
				apiError: true,
				apiSuccess: false
			};
		}

		case COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API: {
			return {
				...state,
				currenciesData: {
					...state.currenciesData,
					apiError: false,
					apiSuccess: false
				}
			};
		}
		case successFor(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API): {
			return {
				...state,
				currenciesData: {
					...state.currenciesData,
					currencies: payload,
					apiSuccess: true,
					apiError: false
				}
			};
		}
		case failedFor(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API): {
			return {
				...state,
				currenciesData: {
					...state.currenciesData,
					currencies: payload,
					apiError: true,
					apiSuccess: false
				}
			};
		}
		case successFor(COMPANY_DETAILS_CONSTANT.GET_API_KEYS):
		case failedFor(COMPANY_DETAILS_CONSTANT.GET_API_KEYS): {
			return {
				...state,
				...payload,
				apiKeys: {
					apiLoader: false,
					apiError: false,
					apiSuccess: false
				}
			};
		}

		case COMPANY_DETAILS_CONSTANT.GET_API_KEYS: {
			return {
				...state,
				apiKeys: {
					apiLoader: COMPANY_DETAILS_CONSTS.GET_KEYS,
					apiError: false,
					apiSuccess: false
				}
			};
		}

		case successFor(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS):
		case failedFor(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS): {
			return {
				...state,
				apiKeys: {
					apiLoader: false,
					...payload
				}
			};
		}

		case COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS: {
			return {
				...state,
				apiKeys: {
					apiLoader: COMPANY_DETAILS_CONSTS.UPDATE_KEYS,
					apiError: false,
					apiSuccess: false
				}
			};
		}

		default: {
			return state;
		}
	}
};
